import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	postSelectList: param => {
		return client
			.get(`${BASE_URL}/comm/common/custCode/v1/cmpnMstCustCodeLists`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	//캠페인 목록 조회
	getCmpnMstList: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		//test

		queryStr = objectToQuerystring({
			cmpnNm: searchParams.cmpnNm /*캠페인명 */,
			partNm: searchParams.partNm /*캠페인품번 */,
			cmpnType: searchParams.cmpnType /* 캠페인 유형 */,
			currentPage,
			pageUnit
		});

		return client
			.get(`${BASE_URL}/mqy/ceqi/cmpnMst/v1/cmpns` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	//캠페인 상세 조회
	getCmpnMstPopList(param) {
		return client
			.get(`${BASE_URL}/mqy/ceqi/cmpnMst/v1/cmpnNo/${param}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	//교환부품목록 조회
	getSearchCmpnPartList(param) {
		return client
			.get(`${BASE_URL}/mqy/ceqi/cmpnMst/v1/cmpnPart/cmpnNo/${param.cmpnNo}/opCd/${param.opCd}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	//캠페인상세 저장
	async postCmpnMst({ saveParams }) {
		try {
			const response = await client.post(`${BASE_URL}/mqy/ceqi/cmpnMst/v1/cmpnMst/status/1`, saveParams);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	//캠페인상세 삭제
	async postDeleteCmpnMst({ cmpnNo, deleteParams }) {
		try {
			const response = await client.post(`${BASE_URL}/mqy/ceqi/cmpnMst/v1/cmpnMst/status/3/cmpnNo/${cmpnNo}`, deleteParams);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	//op코드목록 저장
	async postCmpnOpCdList({ cmpnNo, saveRows }) {
		let url = `${BASE_URL}/mqy/ceqi/cmpnMst/v1/cmpnOpCd/status/1/cmpnNo/${cmpnNo}`;

		return client
			.post(url, saveRows)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	//op코드목록 삭제
	async postDeleteCmpnOpCdList({ cmpnNo, saveRows }) {
		let url = `${BASE_URL}/mqy/ceqi/cmpnMst/v1/cmpnOpCd/status/3/cmpnNo/${cmpnNo}`;

		return client
			.post(url, saveRows)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	//교환부품정보 저장
	async postCmpnPartList({ cmpnNo, opCd, saveRows }) {
		let url = `${BASE_URL}/mqy/ceqi/cmpnMst/v1/cmpnPart/status/1/cmpnNo/${cmpnNo}/opCd/${opCd}`;

		return client
			.post(url, saveRows)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	//교환부품정보 삭제
	async postDeleteCmpnPartList({ cmpnNo, opCd, saveRows }) {
		let url = `${BASE_URL}/mqy/ceqi/cmpnMst/v1/cmpnPart/status/3/cmpnNo/${cmpnNo}/opCd/${opCd}`;

		return client
			.post(url, saveRows)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	async excelTempDown(params) {
		// 엑셀템플릿 다운로드

		try {
			const response = await client.post(`${BASE_URL}/comm/common/qmsFileInfo/v1/downExcelTemp`, params, {
				responseType: 'blob'
			});
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	},

	getPartCost: param => {
		let queryStr = '';
		queryStr = objectToQuerystring({
			partScn: 'PT',
			partNo: param
		});

		return client
			.get(`${BASE_URL}/comm/qmsbase/partCost/v1/partCosts` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},

	getSearchOpCdList: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';

		queryStr = objectToQuerystring({
			opCd: searchParams.opCd /*op코드명 */,
			partNo: searchParams.partNo /*원인부품명 */,
			currentPage,
			pageUnit
		});

		return client
			.get(`${BASE_URL}/mqy/ceqi/cmpnMst/v1/popUpOpCd` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
